export function BusinessProfileLoadingSkeleton() {
  return (
    <div className="business-profile-skeleton max-w-3xl mx-auto p-6 animate-pulse">
      <div className="skeleton-header text-center mb-8">
        <div className="skeleton-title h-8 bg-muted rounded-md w-3/4 mx-auto mb-3"></div>
        <div className="skeleton-subtitle h-4 bg-muted rounded-md w-1/2 mx-auto"></div>
      </div>
      
      <div className="skeleton-fields space-y-6">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="skeleton-field border border-border rounded-lg p-5 bg-card">
            <div className="skeleton-label h-4 bg-muted rounded-md w-1/4 mb-3"></div>
            <div className="skeleton-value h-10 bg-muted rounded-md w-full"></div>
          </div>
        ))}
      </div>
    </div>
  );
}